import Page, { getProps } from '@/modules/investment/distribution/detail'

export const getServerSideProps = getProps

export default Page
